import * as React           from 'react';
import PropTypes            from 'prop-types';
import SelectFieldComponent from './selectfield-component';

export default class SelectFieldContainer extends React.Component {
	render() {
		return <SelectFieldComponent {...this.props} disabled={this.props.disabled || this.props.loading} />;
	}
}

const optionShape = {
	disabled: PropTypes.bool,
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	text: PropTypes.string.isRequired
}

const optGroupShape = {
	disabled: PropTypes.bool,
	label: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(PropTypes.shape(optionShape))
}

SelectFieldContainer.propTypes = {
	disabled   : PropTypes.bool,
	id         : PropTypes.string,
	label      : PropTypes.string,
	loading    : PropTypes.bool,
	name       : PropTypes.string.isRequired,
	nullText   : PropTypes.string,
	onChange   : PropTypes.func,
	options    : PropTypes.arrayOf(PropTypes.shape(optionShape)),
	optGroups  : PropTypes.arrayOf(PropTypes.shape(optGroupShape)),
	placeholder: PropTypes.string,
	readOnly   : PropTypes.bool,
	required   : PropTypes.bool,
	value      : PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}


// WEBPACK FOOTER //
// ./src/component/form/select/selectfield-container.js